export function isItemAFolder(mimeType: string) {
  return mimeType.split('.').pop() === 'folder'
}
